import axios from 'axios';

import WAVELIGHT_URL from './url';

import {
  WavelightMode,
  WorkflowMeasurements,
  WorkflowPerson,
  WorkflowStudy,
} from '../../types';
import {
  WorkflowMetaData,
  WorkflowVideoUploadRequest,
  WorkflowVideoUploadResponse,
} from './types';

import { getAuthToken } from '../../utils';

export const startWorkflow = async (mode: WavelightMode) => {
  const token = getAuthToken();
  const response = await axios.post(
    `${WAVELIGHT_URL}/start/`,
    { mode },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const getPreSignedURL = async (
  id: string,
  fileUpload: WorkflowVideoUploadRequest,
) => {
  const token = getAuthToken();
  const response = await axios.put(
    `${WAVELIGHT_URL}/video-upload/request/${id}/`,
    fileUpload,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const uploadFileOn = async (
  presigned: WorkflowVideoUploadResponse,
  fileBlob: File,
) => {
  const response = await axios.put(presigned.url, fileBlob, {
    headers: {
      'Content-Type': 'application/octet-stream',
    },
  });
  return response.data;
};

export const confirmVideoUpload = async (id: string) => {
  const token = getAuthToken();
  const response = await axios.put(
    `${WAVELIGHT_URL}/video-upload/confirm/${id}/`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const updatePersonData = async (id: string, data: WorkflowPerson) => {
  const token = getAuthToken();
  const response = await axios.put(
    `${WAVELIGHT_URL}/set-person-data/${id}/`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const updateStudyData = async (id: string, data: WorkflowStudy) => {
  const token = getAuthToken();
  const response = await axios.put(
    `${WAVELIGHT_URL}/set-study-data/${id}/`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const updateMeasurements = async (
  id: string,
  data: WorkflowMeasurements,
) => {
  const token = getAuthToken();
  const response = await axios.put(
    `${WAVELIGHT_URL}/set-measurement-data/${id}/`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const updateMetaData = async (id: string, data: WorkflowMetaData) => {
  const token = getAuthToken();
  const response = await axios.put(
    `${WAVELIGHT_URL}/set-metadata/${id}/`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const finishWorkflow = async (id: string) => {
  const token = getAuthToken();
  const response = await axios.put(
    `${WAVELIGHT_URL}/finish/${id}/`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};
